var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 2.66797L6.77629 6.47826C7.21707 6.78681 7.43746 6.94108 7.67718 7.00084C7.88894 7.05362 8.11041 7.05362 8.32217 7.00084C8.56189 6.94108 8.78228 6.78681 9.22306 6.47826L14.6663 2.66797M4.53301 11.3346H11.4663C12.5864 11.3346 13.1465 11.3346 13.5743 11.1166C13.9506 10.9249 14.2566 10.6189 14.4484 10.2426C14.6663 9.81479 14.6663 9.25474 14.6663 8.13463V3.86797C14.6663 2.74786 14.6663 2.18781 14.4484 1.75999C14.2566 1.38366 13.9506 1.0777 13.5743 0.885956C13.1465 0.667969 12.5864 0.667969 11.4663 0.667969H4.53301C3.4129 0.667969 2.85285 0.667969 2.42503 0.885956C2.0487 1.0777 1.74274 1.38366 1.55099 1.75999C1.33301 2.18781 1.33301 2.74786 1.33301 3.86797V8.13463C1.33301 9.25474 1.33301 9.81479 1.55099 10.2426C1.74274 10.6189 2.0487 10.9249 2.42503 11.1166C2.85285 11.3346 3.4129 11.3346 4.53301 11.3346Z",
    stroke: "#475467",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.47ec2a6ddb54404b2e5f0629da01ce1a.svg";
export { ForwardRef as ReactComponent };